/**
 * Canonical form destinations — every entry point that opens a form must use
 * these path + hash values so navigation always lands at the top of the form
 * (heading + first fields), below the sticky header.
 *
 * Anchor IDs belong on the form's top-level container / heading wrapper —
 * never on inputs, field groups, or submit areas.
 */

export const FORM_ANCHORS = {
  talent: {
    id: "talent",
    label: "Talent Submission",
    path: "/submit/talent",
    hash: "talent-submission-form",
  },
  crew: {
    id: "crew",
    label: "Crew & Production Submission",
    path: "/production-network",
    hash: "crew-production-submission-form",
  },
  project: {
    id: "project",
    label: "Project Inquiry",
    path: "/submit/project",
    hash: "project-inquiry-form",
  },
  partner: {
    id: "partner",
    label: "Partner With SoKno",
    path: "/submit/partner",
    hash: "partner-form",
  },
  contact: {
    id: "contact",
    label: "General Inquiry",
    path: "/submit/contact",
    hash: "general-inquiry-form",
  },
};

/** Path → form anchor (first match wins). */
const PATH_TO_ANCHOR = Object.values(FORM_ANCHORS).reduce((acc, entry) => {
  acc[entry.path] = entry;
  return acc;
}, {});

/** Hash id → form anchor */
const HASH_TO_ANCHOR = Object.values(FORM_ANCHORS).reduce((acc, entry) => {
  acc[entry.hash] = entry;
  return acc;
}, {});

export function formHref(key) {
  const entry = FORM_ANCHORS[key];
  if (!entry) return "/submit";
  return `${entry.path}#${entry.hash}`;
}

export function getFormAnchorByPath(pathname) {
  return PATH_TO_ANCHOR[pathname] || null;
}

export function getFormAnchorByHash(hash) {
  if (!hash) return null;
  const id = hash.replace(/^#/, "");
  return HASH_TO_ANCHOR[id] || null;
}

/** All known form hash ids (for validation / tests). */
export function listFormAnchorIds() {
  return Object.values(FORM_ANCHORS).map((e) => e.hash);
}
